// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__phOqr","title":"Info_title__2DRj2","selects":"Info_selects__3wIRK","requiredAsterisk":"Info_requiredAsterisk__1KUIZ"};